import { render } from "./ProfileHeader.vue?vue&type=template&id=06b21ce6"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"

import "./ProfileHeader.vue?vue&type=style&index=0&id=06b21ce6&lang=scss"
script.render = render

export default script